import { Query, gql } from 'apollo-angular';


import { Injectable } from '@angular/core';
import { Resolvers } from '@apollo/client/core';

import { OrderBasicFragment } from './order-basic.fragment';
import { OrderBasic } from '../../models/order-basic';
import { OrderTransaction, TransactionType, TransactionStatus } from '../../models/order-transaction';
import { PaymentMethodType } from '@app/shared/models/enums/payment-method-types';
import { OrderWithTransactions } from '../../models/order-with-transactions';
import { CreditMemo } from '../../models/credit-memo';

@Injectable({
  providedIn: 'root'
})
export class GetOrderPaymentsGQL extends Query<GetOrderTransactionsResponse, GetOrderTransactionsGQLVariables> {
  document = gql`
    query getOrderPayments($orderId: ID!) {
      order(orderId: $orderId) {
        ...OrderBasic
        isPartiallyRefundable
        isFullyRefundable
        transactions @client
        creditMemos {
          insertedByUserFullName
          insertedDate
          notes
          total
          adjustmentAmount
          items {
            refundedQuantity
            refundedAmount
            orderItem {
              name
            }
          }
        }
        payments {
          method
          insertedDate
          transactions {
            date: insertedDate
            amount
            type
            result {
              message
              transactionId
              status
            }
          }
        }
      }
    }
    ${OrderBasicFragment}
  `;
}


interface OrderPaymentQuery {
  order: OrderBasic;
  creditMemos: CreditMemo[];
  payments: {
    method: PaymentMethodType;
    transactions: {
      date: Date;
      amount: number;
      type: TransactionType;
      status: TransactionStatus;
      result?: {
        transactionId?: string;
        message?: string;
        status: TransactionStatus;
      }
    }[];
  }[];
}

interface GetOrderTransactionsResponse {
  order: OrderWithTransactions;
}

interface GetOrderTransactionsGQLVariables {
  orderId: string;
}

export const OrderTransactionsResolver: Resolvers = {
  Order: {
    transactions: (query: OrderPaymentQuery) => query.payments.reduce(
      (mappedTransactions, payment) => {
        const mapped = payment.transactions
          .filter(trans => {
            return trans.type !== 'AUTHORIZE' || trans.result.status !== 'APPROVED';
          })
          .map(trans => {
            const ot: OrderTransaction = {
              ...trans,
              method: payment.method,
              type: trans.type,
              status: trans.result.status,
              merchant: 'Auth.net'
            };
            if (trans.result) {
              ot.message = trans.result.message;
              ot.merchantTransactionId = trans.result.transactionId;
            }
            return ot;
          });
        return mappedTransactions.concat(...mapped);
      }, [])
  }
};
